module.exports = {"StatusCode":200,"Payload":"[{\"domain\":\"ACTIVE\",\"cert\":\"active\"}]"}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/getDomainStatus.json
// module id = oxmj
// module chunks = 0